import { restrictedRoute } from "@/routing/routes";
import { createRoute } from "@tanstack/react-router";
import { RegisterConfirmPage } from "./Confirm";
import { RegisterFormPage } from "./Form";
import { RegisterReviewPage } from "./Review";
import { RegisterTermsPage } from "./Terms";

const index = createRoute({
  path: "register",
  getParentRoute: () => restrictedRoute,
});

const review = createRoute({
  path: "review",
  getParentRoute: () => index,
  component: RegisterReviewPage,
});

const terms = createRoute({
  path: "terms",
  getParentRoute: () => index,
  component: RegisterTermsPage,
});

const form = createRoute({
  path: "form",
  getParentRoute: () => index,
  component: RegisterFormPage,
});

const confirm = createRoute({
  path: "confirm",
  getParentRoute: () => index,
  component: RegisterConfirmPage,
});

export const registerRoutes = index.addChildren([review, terms, form, confirm]);
